import type { SourceSpec } from './entities';
import type { SimState } from './state';
import { samePos } from './types';
import type { EntityId, GridPos } from './types';

export interface EntityRef {
  kind: 'observable' | 'sink' | 'machine' | 'conveyor' | 'subject';
  id: EntityId;
}

export function inBounds(state: SimState, pos: GridPos): boolean {
  return pos.x >= 0 && pos.y >= 0 && pos.x < state.grid.width && pos.y < state.grid.height;
}

export function findSource(state: SimState, pos: GridPos): SourceSpec | undefined {
  return state.sources.find((source) => samePos(source.position, pos));
}

export function findEntityAt(state: SimState, pos: GridPos): EntityRef | undefined {
  for (const observable of Object.values(state.observables)) {
    if (samePos(observable.position, pos)) return { kind: 'observable', id: observable.id };
  }
  for (const sink of Object.values(state.sinks)) {
    if (samePos(sink.position, pos)) return { kind: 'sink', id: sink.id };
  }
  for (const machine of Object.values(state.machines)) {
    if (samePos(machine.position, pos)) return { kind: 'machine', id: machine.id };
  }
  for (const conveyor of Object.values(state.conveyors)) {
    if (samePos(conveyor.position, pos)) return { kind: 'conveyor', id: conveyor.id };
  }
  for (const subject of Object.values(state.subjects)) {
    if (samePos(subject.position, pos)) return { kind: 'subject', id: subject.id };
  }
  return undefined;
}
